import { Component } from '@angular/core';
import * as fromGroups from '../../reducers/groups.reducer';
import * as fromRoot from '@app/reducers';
import { Group } from '@app/shared/models/group';
import { DialogRef } from '@ngneat/dialog';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { GroupsActions } from '../../actions';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-modal-detach-role',
  templateUrl: './modal-detach-role.component.html',
  styleUrls: ['./modal-detach-role.component.scss']
})
export class ModalDetachRoleComponent {

  roleToDetach: any;
  group: Group;
  teamId: string;

  detachRoleFromGroupPending$: Observable<boolean>;
  detachRoleFromGroupSuccess$: Observable<boolean>;
  detachRoleFromGroupError$: Observable<any>;

  submitted = false;
  subscriptions: Subscription[] = [];

  constructor(private store$: Store<fromRoot.State & fromGroups.State>, public ref: DialogRef, private translateService: TranslateService) {
    this.roleToDetach = this.ref.data.roleToDetach;
    this.group = this.ref.data.group;
    this.teamId = this.ref.data.teamId;

    this.detachRoleFromGroupPending$ = this.store$.select(fromGroups.getDetachRoleFromGroupPending);
    this.detachRoleFromGroupSuccess$ = this.store$.select(fromGroups.getDetachRoleFromGroupSuccess);
    this.detachRoleFromGroupError$ = this.store$.select(fromGroups.getDetachRoleFromGroupError);
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => {
      sub.unsubscribe();
    });
  }

  close() {
    this.ref.close();
  }

  detachRoleFromGroup() {
    this.submitted = true;
    this.store$.dispatch(GroupsActions.DetachRoleFromGroup({ teamId: this.teamId, role: { ...this.roleToDetach }, groupId: this.group.id }));
    this.subscriptions.push(
      this.detachRoleFromGroupSuccess$.subscribe(res => {
        if (res) {
          this.store$.dispatch(GroupsActions.LoadGroupRoles({ teamId: this.teamId, id: this.group.id }));
          this.close();
        }
      })
    );
  }
}
